import { LoadingOverlay } from "../LoadingOverlay";

export function LoadingOutlet() {
  return (
    <div className="flex items-start justify-center px-4 py-6 mb-15">
      <LoadingOverlay />
      <div className="w-full max-w-3xl animate-pulse">
        {/* Title bar skeleton */}
        <div className="flex justify-center mb-8">
          <div className="h-8 w-48 bg-gray-700 rounded-full" />
        </div>

        {/* Step indicator skeleton: 3 dots with connectors */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <span className="w-5 h-5 rounded-full bg-gray-700" />
          <span className="w-8 h-px bg-gray-700" />
          <span className="w-5 h-5 rounded-full bg-gray-700" />
          <span className="w-8 h-px bg-gray-700" />
          <span className="w-5 h-5 rounded-full bg-gray-700" />
        </div>

        {/* Two CTA-card skeletons */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[0, 1].map((i) => (
            <div
              key={i}
              className="bg-gray-800 rounded-xl overflow-hidden border border-gray-700"
            >
              <div className="w-full h-32 bg-gray-700" />
              <div className="p-6 pt-4 space-y-3">
                <div className="h-4 bg-gray-700 rounded w-3/4" />
                <div className="h-3 bg-gray-700 rounded w-full" />
                <div className="h-9 bg-gray-700 rounded w-32 mt-4" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
